<template>
  <li
    class="m-nav__item m-topbar__user-profile m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
    m-dropdown-toggle="click"
  >
    <a href="#" class="m-nav__link m-dropdown__toggle">
      <span class="m-topbar__userpic">
        <img
          src="@/assets/media/img/users/user.png"
          class="m--img-rounded m--marginless m--img-centered"
          alt=""
        />
      </span>
      <span class="m-nav__link-icon m-topbar__usericon m--hide">
        <span class="m-nav__link-icon-wrapper"><i class="flaticon-user-ok"></i></span>
      </span>
      <span class="m-topbar__username m--hide">{{ user.name }}</span>
    </a>
    <div class="m-dropdown__wrapper">
      <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
      <div class="m-dropdown__inner">
        <div class="m-dropdown__header m--align-center">
          <div class="m-card-user m-card-user--skin-light">
            <div class="m-card-user__pic">
              <img
                src="@/assets/media/img/users/user.png"
                class="m--img-rounded m--marginless"
                alt=""
              />
            </div>
            <div class="m-card-user__details">
              <span class="m-card-user__name m--font-weight-500">{{ user.name }}</span>
              <a href="" class="m-card-user__email m--font-weight-300 m-link">
                {{ user.email.length > 22 ? user.email.substr(0, 22) + '...' : user.email }}
              </a>
            </div>
          </div>
        </div>
        <div class="m-dropdown__body">
          <div class="m-dropdown__content">
            <ul class="m-nav m-nav--skin-light">
              <li class="m-nav__section m--hide">
                <span class="m-nav__section-text">Section</span>
              </li>
              <li class="m-nav__item">
                <a href="/profile" class="m-nav__link">
                  <i class="m-nav__link-icon flaticon-user"></i>
                  <span class="m-nav__link-title">
                    <span class="m-nav__link-wrap">
                      <span class="m-nav__link-text">Meu perfil</span>
                    </span>
                  </span>
                </a>
              </li>
              <li class="m-nav__separator m-nav__separator--fit"></li>
              <li class="m-nav__separator m-nav__separator--fit"></li>
              <li class="m-nav__item">
                <a
                  href="#"
                  @click.prevent="logout()"
                  class="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder"
                >
                  <i class="fal fa-sign-out"></i>
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { userKey, passportTokenKey, showError, baseApiUrl } from '@/global';
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  name: 'UserDropdown',
  computed: mapState(['user']),
  methods: {
    logout() {
      axios
        .post(`${baseApiUrl}/logout`)
        .then((res) => {
          if (res.status === 200) {
            localStorage.removeItem(userKey);
            localStorage.removeItem(passportTokenKey);
            this.$store.commit('setUser', null);
            this.$store.commit('setUserScope', null);
            this.$store.commit('setToken', null);
            this.$store.commit('setContaAzulAuthorized', false);
            this.$router.push({ name: 'auth' });
          }
        })
        .catch(showError);
    },
  },
};
</script>

<style></style>
